<template>
  <tr class="evaluation-table-row">
    <td class="typography--body-2 evaluation-table-td evaluation-table-student-number">
      {{ evaluation.number || '-' }}
    </td>
    <td class="typography--body-2 evaluation-table-td evaluation-table-student-name">
      {{ evaluation.name }}
    </td>
    <td class="typography--body-2 evaluation-table-td evaluation-table-comment" v-if="evaluationComment && !loading">
      {{ evaluationComment }}

      <div class="evaluation-table-row-actions">
        <EvaluationBadge v-for="domain in domains"
                         v-bind:key="domain.id"
                         v-bind:domain="domain">
        </EvaluationBadge>

        <button class="btn rounded-circle copy-evaluation-btn float-right"
                v-clipboard="evaluationComment"
                v-on:success="$root.$emit('show::snackbar', snackbarOptions)"
                v-bind:title="$t('evaluations.table.btn.copied_to_clipboard')"></button>

        <button class="btn rounded-circle refresh-evaluation-btn float-right mr-6"
                v-on:click="refreshEvaluation()"
                v-bind:title="$t('evaluations.table.btn.refresh')"></button>
      </div>
    </td>
    <td class="typography--body-2 typography--color-disabled evaluation-table-td evaluation-table-comment" v-if="!evaluationComment && !loading">
      <span v-if="evaluationNotSupported">{{ $t('evaluations.table.comment_not_supported') }}</span>
      <span v-else>{{ $t('evaluations.table.comment_empty') }}</span>
    </td>
    <td class="evaluation-table-td evaluation-table-comment" v-if="loading">
      <LoadingBounce class="float-left"></LoadingBounce>
    </td>
  </tr>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { zipWith } from 'lodash';
  import EvaluationBadge from './EvaluationBadge';

  export default {
    name: 'evaluation-table-row',

    components: {
      EvaluationBadge,
    },

    props: {
      evaluation: {
        type: Object,
        default: null,
      },
      selectedDomainIds: {
        type: Array,
        default: () => ([]),
      },
    },

    data() {
      return {
        loading: false,

        snackbarOptions: {
          message: this.$t('evaluations.snackbar.copied_to_clipboard'),
          actionText: this.$t('evaluations.snackbar.dismiss'),
          actionHandler() {},
        },
      };
    },

    computed: {
      ...mapGetters([
        'evaluationFilters',
      ]),

      evaluationComment() {
        if (this.evaluation &&
            this.evaluation.evaluation &&
            this.evaluation.evaluation !== '작성 가능한 과제 활동이 없습니다.') {
          return this.evaluation.evaluation;
        }

        return null;
      },

      evaluationNotSupported() {
        if (this.evaluation) {
          return this.evaluation.not_supported;
        }

        return false;
      },

      domains() {
        if (this.evaluation &&
            this.evaluation.domains_id &&
            this.evaluation.domains_name &&
            this.evaluation.domains_grade) {
          const domainIds = this.evaluation.domains_id.split(',');
          const domainNames = this.evaluation.domains_name.split(',');
          const domainGrades = this.evaluation.domains_grade.split(',');

          return zipWith(domainIds, domainNames, domainGrades, (id, name, grade) => ({
            id,
            name,
            grade,
          }));
        }

        return [];
      },
    },

    methods: {
      ...mapActions([
        'fetchEvaluation',
      ]),

      refreshEvaluation() {
        this.loading = true;

        const params = {
          studentId: this.evaluation.student_id,
          filters: {
            ...this.evaluationFilters,
            domains: this.selectedDomainIds.join(','),
          },
          index: this.evaluation.index,
        };

        this.fetchEvaluation(params)
          .then(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style lang="scss">
  .evaluation-table-row {
    .evaluation-table-td {
      padding-left: 22px;
      padding-top: 12px;
      padding-bottom: 14px;
      padding-right: 8px;
      word-break: break-all;

      &.evaluation-table-student-number {
        width: 55px;
      }

      &.evaluation-table-student-name {
        width: 124px;
      }

      &.evaluation-table-comment {
        padding-right: 20px;
        white-space: normal;
      }
    }

    .evaluation-table-row-actions {
      margin-top: 14px;

      .copy-evaluation-btn,
      .refresh-evaluation-btn {
        width: 26px;
        height: 26px;
        padding: 0;
        border: none;
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat;

        &:focus {
          box-shadow: none;
        }
      }

      .copy-evaluation-btn {
        background-image: url('/static/images/ic-copy-default.png');

        &:hover {
          background-image: url('/static/images/ic-copy-hover.png');
        }

        &:active {
          background-image: url('/static/images/ic-copy-on-click.png');
        }
      }

      .refresh-evaluation-btn {
        background-image: url('/static/images/ic-refresh-default.png');

        &:hover {
          background-image: url('/static/images/ic-refresh-hover.png');
        }

        &:active {
          background-image: url('/static/images/ic-refresh-on-click.png');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/evaluations/components/EvaluationTableRow.vue